<template>
  <div class="approvals-flow-edit px-8 pt-6 pb-6">
    <ApprovalsPanelBackButton
      class="mb-6"
      @click="handleBack"
    />

    <div class="text-h1 text-textDarkest mb-6">
      Update Approval Flow
    </div>

    <div
      v-if="activeFlow"
      class="d-flex flex-column ga-6 mb-6"
    >
      <ApprovalFlowStage
        v-for="stage in activeFlow.stages"
        :key="`${activeFlow.ulid}-${stage.stage_number}`"
        :stage="stage"
        mode="edit"
        :approval-slot-selected-users="editApprovalSlotSelectedUsers"
        @update:approval-slot-selected-users="updateEditApprovalSlotApprovers"
      />
    </div>

    <DpplNewButton
      class="w-100"
      color="primary"
      height="40"
      :disabled="!canSubmitEditFlow || isSavingApprovers"
      :loading="isSavingApprovers"
      @click="handleSave"
    >
      Save Approval Flow
    </DpplNewButton>
  </div>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import ApprovalFlowStage from '@/components/jobProfiles/editor/approvals/ApprovalFlowStage.vue';
import ApprovalsPanelBackButton from '@/components/jobProfiles/editor/approvals/ApprovalsPanelBackButton.vue';
import DpplNewButton from '@/components/datapeople/DpplNewButton.vue';
import { useApprovalFlows } from '@/stores/jobProfiles/approvalFlows';
import { useAppSnackbar } from '@/stores/app/snackbar';
import { useTracking } from '@/stores/tracking/tracking';

const { addErrorSnackbar, addSuccessSnackbar } = useAppSnackbar();

const approvalFlowsStore = useApprovalFlows();
const {
  activeFlow,
  editApprovalSlotSelectedUsers,
  canSubmitEditFlow,
  isSavingApprovers,
} = storeToRefs(approvalFlowsStore);
const {
  backToFlowDetail,
  updateEditApprovalSlotApprovers,
  saveAddedApprovers,
} = approvalFlowsStore;

const handleBack = () => {
  backToFlowDetail();
};

const handleSave = async () => {
  try {
    await saveAddedApprovers();

    useTracking().approvalPanelSavedFlowChanges();

    addSuccessSnackbar({
      text: 'Approval flow updated',
    });
  } catch (error) {
    addErrorSnackbar({
      text: `Failed to update approval flow — ${error.message}`,
    });

    throw error;
  }
};
</script>
